// removed by extract-text-webpack-plugin
module.exports = {"scroller":"_3caL","scrollingContainer":"tKAx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagescreen/scroller/style.css
// module id = 365
// module chunks = 9